import { render, staticRenderFns } from "./TicketEditSubjectModal.vue?vue&type=template&id=99a3ae4c&scoped=true&"
import script from "./TicketEditSubjectModal.vue?vue&type=script&lang=ts&"
export * from "./TicketEditSubjectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a3ae4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99a3ae4c')) {
      api.createRecord('99a3ae4c', component.options)
    } else {
      api.reload('99a3ae4c', component.options)
    }
    module.hot.accept("./TicketEditSubjectModal.vue?vue&type=template&id=99a3ae4c&scoped=true&", function () {
      api.rerender('99a3ae4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketEditSubjectModal.vue"
export default component.exports